import { atom } from 'jotai'
import type { createStore } from 'jotai'
import { atomWithQuery } from 'jotai-tanstack-query'
import { hc, type InferResponseType } from 'hono/client'
import type { ChangelogApi } from '@backend/api/stores/ChangelogStore'
import { apiFetch } from '@paraflow-ai/frontend-libs'

type Store = ReturnType<typeof createStore>
const api = hc<ChangelogApi>('/api/stores/changelog', { fetch: apiFetch })

export const filterComponentAtom = atom('')

export const refreshAtom = atomWithQuery(() => ({
  queryKey: ['ChangelogStore'],
  queryFn: async () => {
    const res = await api.refresh.$get()
    return await res.json()
  },
}))

export function loader(store: Store) {
  store.set(filterComponentAtom, '')
  store.get(refreshAtom)
  return null
}
